import { Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HHSGSharedTabConfig } from '../../../../models/tab-config.model';
import { Constants } from '../../../../utilities/constants.util';

@Component({
  selector: 'lib-rich-text-box',
  templateUrl: 'rich-text-box.component.html',
  styleUrls: ['rich-text-box.component.scss'],
  providers:[
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting:forwardRef(()=>HHSGSharedRichTextBoxComponent),
      multi:true,
    }
  ]
})

export class HHSGSharedRichTextBoxComponent implements OnInit,ControlValueAccessor {
  value:string;
  isMultiline = true;
  
  tabs: HHSGSharedTabConfig[];

  currentTab: string[];
  dxiMap : Map<string, string[]> =new Map();
  @Input() isRequired = false;
  @Input() placeholder:string = "Type Notification Here";
  @Output() showMessageBoxError: EventEmitter<boolean>  = new EventEmitter();
  @Input() maxItems: number = 1000;

  onChange : (value:any) =>void
  onTouch : () => void;
  constructor() { }

  onValueChanged(e) {
    if(e.value != null && e.value.length > 0)
    {
        this.showMessageBoxError.emit(false);
    }
    else{
      this.showMessageBoxError.emit(true);
    }
    if(e.value != null && e.value.length > (this.maxItems + 7)){ //RichTextEditor adds <p> and </p> tags to the input value. 
      let newValue = e.value.slice(0, (this.maxItems-6)); 
      e.component.option("value", newValue);
  } 
    this.onChange(e);
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange=fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch=fn;
  }

  ngOnInit(): void {
    this.dxiMap.set('undo',['']);
    this.dxiMap.set('redo',['']);
    this.dxiMap.set('separator',['']);
    this.dxiMap.set('size',Constants.NotificationSizeAcceptedValues);
    this.dxiMap.set('font',Constants.NotificationFontAcceptedValues);
    this.dxiMap.set('separator',['']);
    this.dxiMap.set('bold',['']);
    this.dxiMap.set('italic',['']);
    this.dxiMap.set('strike',['']);
    this.dxiMap.set('underline',['']);
    this.dxiMap.set('separator',['']);
    this.dxiMap.set('alignLeft', ['']);
    this.dxiMap.set('alignLeft', ['']);
    this.dxiMap.set('alignCenter', ['']);
    this.dxiMap.set('alignRight', ['']);
    this.dxiMap.set('alignJustify',[''])
    this.dxiMap.set('separator',['']);
    this.dxiMap.set('orderedList',['']);
    this.dxiMap.set('bulletList',['']);
    this.dxiMap.set('separator',['']);
    this.dxiMap.set('header',Constants.NotificationHeaderAcceptedValues);
    this.dxiMap.set('separator',['']);
    this.dxiMap.set('color',['']);
    this.dxiMap.set('background',['']);
    this.dxiMap.set('separator',['']);
    this.dxiMap.set('link',['']);
    this.dxiMap.set('separator',['']);
    this.dxiMap.set('clear',['']);
    this.dxiMap.set('separator',['']);
    // this.dxiMap.set('insertTable',['']);
    // this.dxiMap.set('deleteTable',['']);
    // this.dxiMap.set('insertRowAbove',['']);
    // this.dxiMap.set('insertRowBelow',['']);
    // this.dxiMap.set('deleteRow',['']);
    // this.dxiMap.set('insertColumnLeft',['']);
    // this.dxiMap.set('insertColumnRight',['']);
    // this.dxiMap.set('deleteColumn',['']);
  }

}
